import React, { Component } from "react";
import PropTypes from "prop-types";
import SidebarSkeleton from "./SidebarSkeleton";
import "./page-has-sidebar.scss";

class SidebarContainer extends Component {
  componentDidMount() {
    document.body.classList.toggle("page-has-sidebar");
  }

  componentWillUnmount() {
    document.body.classList.remove("page-has-sidebar");
  }

  render() {
    const { showLoadingSkeleton, children } = this.props;
    return showLoadingSkeleton ? <SidebarSkeleton /> : children;
  }
}

SidebarContainer.propTypes = {
  showLoadingSkeleton: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default SidebarContainer;
